var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thumbnail-wrap",
    class: ("thumbnail-wrap-" + _vm.mode)
  }, [(_vm.gender === 'man') ? _c('img', {
    staticClass: "round-image",
    attrs: {
      "width": _vm.width,
      "height": _vm.width,
      "src": require("./images/touxiang.jpg"),
      "alt": "thumbnail"
    }
  }) : _c('img', {
    staticClass: "round-image",
    attrs: {
      "width": _vm.width,
      "height": _vm.width,
      "src": require("./images/woman.jpg"),
      "alt": "thumbnail"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "thumbnail-text",
    style: ({
      fontSize: _vm.fontSize + 'px'
    })
  }, [(_vm.$slots.default) ? _vm._t("default") : (_vm.text.length) ? [_c('p', {
    domProps: {
      "textContent": _vm._s(_vm.text)
    }
  })] : _vm._e()], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b0ac60b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/thumbnail/src/main.vue
// module id = null
// module chunks = 